'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n    line-height: 20px;\n    height: 20px;\n  '], ['\n    line-height: 20px;\n    height: 20px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    line-height: 28px;\n    height: 28px;\n  '], ['\n    line-height: 28px;\n    height: 28px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    line-height: 36px;\n    height: 36px;\n  '], ['\n    line-height: 36px;\n    height: 36px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background: ', ';\n  padding: 0px 10px;\n  ', ' overflow: hidden;\n  cursor: pointer;\n  ', ';\n'], ['\n  background: ', ';\n  padding: 0px 10px;\n  ', ' overflow: hidden;\n  cursor: pointer;\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 10px !important;\n  ', ';\n'], ['\n  color: ', ';\n  font-size: 10px !important;\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _DropDown = require('../../DropDown/DropDown');

var _DropDown2 = _interopRequireDefault(_DropDown);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _SimpleMenu = require('../../SimpleMenu/SimpleMenu');

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var sizes = {
  small: (0, _styledComponents.css)(_templateObject),
  normal: (0, _styledComponents.css)(_templateObject2),
  large: (0, _styledComponents.css)(_templateObject3)
};

var InputTabContainer = _styledComponents2.default.div(_templateObject4, _colors.grey, function (_ref) {
  var position = _ref.position;
  return 'padding-' + position + ': 8px;';
}, function (_ref2) {
  var size = _ref2.size;
  return sizes[size];
});

var TabIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5, _colors.darkGrey, function (_ref3) {
  var position = _ref3.position;
  return 'margin-' + position + ': 6px;';
});

var InputTab = function (_Component) {
  _inherits(InputTab, _Component);

  function InputTab() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, InputTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = InputTab.__proto__ || Object.getPrototypeOf(InputTab)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _this.open = function () {
      if (_this.state.visible) return;

      _this.setState({
        visible: true
      });
    }, _this.close = function () {
      if (!_this.state.visible) return;

      _this.setState({
        visible: false
      });
    }, _this.icon = function () {
      return _this.state.visible ? 'up' : 'down';
    }, _this.onSelect = function (value) {
      _this.close();

      _this.props.onChange(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputTab, [{
    key: 'renderDropDown',
    value: function renderDropDown(dom) {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          width = _props.width;
      var visible = this.state.visible;
      return !options.length ? dom : _react2.default.createElement(_DropDown2.default, {
        visible: visible,
        onOpen: this.open,
        onClose: this.close,
        trigger: dom,
        size: width
      }, _react2.default.createElement(_SimpleMenu2.default, {
        options: options,
        selected: [value],
        onSelect: this.onSelect
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          options = _props2.options,
          size = _props2.size,
          position = _props2.position;
      return this.renderDropDown(_react2.default.createElement(InputTabContainer, {
        size: size,
        position: position
      }, options.length > 0 && position === 'right' && _react2.default.createElement(TabIcon, {
        icon: this.icon(),
        position: position
      }), value, options.length > 0 && position === 'left' && _react2.default.createElement(TabIcon, {
        icon: this.icon(),
        position: position
      })));
    }
  }]);

  return InputTab;
}(_react.Component);

InputTab.propTypes = {
  value: _propTypes2.default.string,
  options: _propTypes2.default.array,
  size: _propTypes2.default.oneOf(['small', 'normal', 'large']),
  position: _propTypes2.default.oneOf(['left', 'right']),
  onChange: _propTypes2.default.func,
  width: _propTypes2.default.number
};
InputTab.defaultProps = {
  options: [],
  position: 'left'
};
exports.default = InputTab;